import type { LoaderFunction } from 'react-router-dom';
import { getMagnoliaBaseUrl } from '../util';
import { getAppBase } from '../util/getMagnoliaBaseUrl';

export const magnoliaPageLoader: LoaderFunction = async ({ request }) => {
	const url = new URL(request.url);
	const magnoliaBaseUrl = getMagnoliaBaseUrl();
	const fullContentPath =
		magnoliaBaseUrl + process.env.MGNL_API_PAGES! + getAppBase() + url.pathname;

	const pageResponse = await fetch(fullContentPath);
	if (pageResponse.status != 200) {
		throw new Error(pageResponse.statusText);
	}
	const pageJson = await pageResponse.json();
	return { pageJson };
};
